// Classes
class Currency {
    constructor(data) {
        var self = this;
        self.type = "Currency";
        self.iso_currency_code = data.iso_currency_code;
        self.title = data.title;
        self.symbol = data.symbol;
    }
}


// Constants
export const GIFT_CARD_STATUSES = [
    { 'title': 'Enabled - Paid for', 'value': 'enabled' },
    { 'title': 'Redeemed - Used', 'value': 'redeemed' },
    { 'title': 'Created - not yet paid for', 'value': 'created' },
    { 'title': 'Failed', 'value': 'failed' },
    { 'title': 'Expired', 'value': 'expired' },
    { 'title': 'Canceled', 'value': 'canceled' }
];

export const LEGALFORM_TYPES = [
    {
        value: "individual", artist_label: 'profile.artist.invoice.legalform.individual',
        label: 'general.invoice.legalform.individual'
    },
    {
        value: "company", artist_label: 'profile.artist.invoice.legalform.company',
        label: 'general.invoice.legalform.company'
    },
    {
        value: "organization", artist_label: 'profile.artist.invoice.legalform.organization',
        label: 'general.invoice.legalform.organization'
    },
    {
        value: "entrepreneur", artist_label: 'profile.artist.invoice.legalform.entrepreneur',
        label: 'general.invoice.legalform.entrepreneur'
    }
];

export const TAXRATE_TYPES = [
    { value: "smallbusiness", label: 'profile.artist.invoice.taxrate.smallbusiness', percentage: 0, country_abr: 'de' },
    { value: "frreduced", label: 'profile.artist.invoice.taxrate.frreduced', percentage: 5.5, country_abr: 'fr' },
    { value: "nlreduced", label: 'profile.artist.invoice.taxrate.nlreduced', percentage: 6, country_abr: 'nl' },
    { value: "artistreduced", label: 'profile.artist.invoice.taxrate.artistreduced', percentage: 7, country_abr: 'de' },
    { value: "swiss", label: 'profile.artist.invoice.taxrate.swiss', percentage: 7.7, country_abr: 'ch' },
    {
        value: "spain", label: 'profile.artist.invoice.taxrate.spain', percentage: 10,
        country_abr: 'es'
    },
    { value: "austriareduced", label: 'profile.artist.invoice.taxrate.austriareduced', percentage: 13, country_abr: 'at' },
    { value: "austriaregular", label: 'profile.artist.invoice.taxrate.austriaregular', percentage: 20, country_abr: 'at' },
    { value: "fulltax", label: 'profile.artist.invoice.taxrate.fulltax', percentage: 19, country_abr: 'de' },
    { value: "frenchtax", label: 'profile.artist.invoice.taxrate.frenchtax', percentage: 0, country_abr: 'fr' },
    { value: "us-default", label: 'profile.artist.invoice.taxrate.usdefault', percentage: 0, country_abr: 'us' },
    { value: "ca-default", label: 'profile.artist.invoice.taxrate.cadefault', percentage: 0, country_abr: 'ca' },
    {
        value: "custom", label: 'profile.artist.invoice.taxrate.custom', percentage: 0,
        country_abr: 'all'
    },

];

export const VIDEO_MESSAGE_PRICES = [
    { value: 45, short_label: '45 €', label: 'video_message_checkout.prices.45', biz: false },
    { value: 55, short_label: '55 €', label: 'video_message_checkout.prices.55', biz: false },
    { value: 75, short_label: '75 €', label: 'video_message_checkout.prices.75', biz: false },
    { value: 100, short_label: '100 €', label: 'video_message_checkout.prices.100', biz: false },
    { value: 150, short_label: '150 €', label: 'video_message_checkout.prices.150', biz: false },
    { value: 200, short_label: '200 €', label: 'video_message_checkout.prices.200', biz: false },
    { value: 250, short_label: '250 €', label: 'video_message_checkout.prices.250', biz: false },
    { value: 300, short_label: '300 €', label: 'video_message_checkout.prices.300', biz: false },
    { value: 350, short_label: '350 €', label: 'video_message_checkout.prices.350', biz: false },
    { value: 400, short_label: '400 €', label: 'video_message_checkout.prices.400', biz: false },
    { value: 450, short_label: '450 €', label: 'video_message_checkout.prices.450', biz: false },
    { value: 500, short_label: '500 €', label: 'video_message_checkout.prices.500', biz: false },
    { value: 550, short_label: '550 €', label: 'video_message_checkout.prices.550', biz: false },
    { value: 600, short_label: '600 €', label: 'video_message_checkout.prices.600', biz: false },
    { value: 650, short_label: '650 €', label: 'video_message_checkout.prices.650', biz: false },
    { value: 700, short_label: '700 €', label: 'video_message_checkout.prices.700', biz: false },
    { value: 750, short_label: '750 €', label: 'video_message_checkout.prices.750', biz: false },
    { value: 800, short_label: '800 €', label: 'video_message_checkout.prices.800', biz: false },
    { value: 850, short_label: '850 €', label: 'video_message_checkout.prices.850', biz: false },
    { value: 900, short_label: '900 €', label: 'video_message_checkout.prices.900', biz: false },
    { value: 950, short_label: '950 €', label: 'video_message_checkout.prices.950', biz: false },
    { value: 1000, short_label: '1000 €', label: 'video_message_checkout.prices.1000', biz: false },
    { value: 1050, short_label: '1050 €', label: 'video_message_checkout.prices.1050', biz: false },
    { value: 1100, short_label: '1100 €', label: 'video_message_checkout.prices.1100', biz: false },
    { value: 1150, short_label: '1150 €', label: 'video_message_checkout.prices.1150', biz: false },
    { value: 1200, short_label: '1200 €', label: 'video_message_checkout.prices.1200', biz: false },
    { value: 1250, short_label: '1250 €', label: 'video_message_checkout.prices.1250', biz: false },
    { value: 1300, short_label: '1300 €', label: 'video_message_checkout.prices.1300', biz: false },
    { value: 1350, short_label: '1350 €', label: 'video_message_checkout.prices.1350', biz: false },
    { value: 1400, short_label: '1400 €', label: 'video_message_checkout.prices.1400', biz: false },
    { value: 1450, short_label: '1450 €', label: 'video_message_checkout.prices.1450', biz: false },
    { value: 1500, short_label: '1500 €', label: 'video_message_checkout.prices.1500', biz: false },
    { value: 1550, short_label: '1550 €', label: 'video_message_checkout.prices.1550', biz: false },
    { value: 1600, short_label: '1600 €', label: 'video_message_checkout.prices.1600', biz: false },
    { value: 1650, short_label: '1650 €', label: 'video_message_checkout.prices.1650', biz: false },
    { value: 1700, short_label: '1700 €', label: 'video_message_checkout.prices.1700', biz: false },
    { value: 1750, short_label: '1750 €', label: 'video_message_checkout.prices.1750', biz: false },
    { value: 1800, short_label: '1800 €', label: 'video_message_checkout.prices.1800', biz: false },
    { value: 1850, short_label: '1850 €', label: 'video_message_checkout.prices.1850', biz: false },
    { value: 1900, short_label: '1900 €', label: 'video_message_checkout.prices.1900', biz: false },
    { value: 1950, short_label: '1950 €', label: 'video_message_checkout.prices.1950', biz: false },
    { value: 2000, short_label: '2000 €', label: 'video_message_checkout.prices.2000', biz: false },
    { value: 750, short_label: '750 €', label: 'video_message_checkout.biz_prices.750', biz: true },
    { value: 1000, short_label: '1000 €', label: 'video_message_checkout.biz_prices.1000', biz: true },
    { value: 1250, short_label: '1250 €', label: 'video_message_checkout.biz_prices.1250', biz: true },
];

export const NO_OPTIONS = [
    { label: 'modal.denyreason.artist.wrongdate', perspective: 'artist' },
    { label: 'modal.denyreason.artist.othergig', perspective: 'artist' },
    { label: 'modal.denyreason.artist.noplans', perspective: 'artist' },
    { label: 'modal.denyreason.artist.other', perspective: 'artist' },
    { label: 'modal.denyreason.host.wrongdate', perspective: 'host' },
    { label: 'modal.denyreason.host.wronggenre', perspective: 'host' },
    { label: 'modal.denyreason.host.noplans', perspective: 'host' },
    { label: 'modal.denyreason.host.other', perspective: 'host' }
]


export const EQUIPMENT_TYPES = [
    { value: 'yes', label: 'equipment.manage.yes' },
    { value: 'maybe', label: 'equipment.manage.maybe' },
    { value: 'no', label: 'equipment.manage.no' },
    { value: 'unplugged', label: 'equipment.manage.unplugged' },
];

export const LODGING_TYPES = [
    { value: 'yes', label: 'lodging.manage.yes' },
    { value: 'maybe', label: 'lodging.manage.maybe' },
    { value: 'no', label: 'lodging.manage.no' }
];

export const AVAILABILITY_TYPES = [
    { value: 'anytime', label: 'available.anytime' },
    { value: 'weekend', label: 'available.weekend' },
    //{value:'justnot', label: 'available.pause'},
    { value: 'seenote', label: 'available.seenote' }
];

export const PAUSE_TYPES = [
    {
        value: '14',
        label: 'profile.host.availability.pause.period.2weeks'
    },
    {
        value: '28',
        label: 'profile.host.availability.pause.period.4weeks'
    },
    {
        value: '30',
        label: 'profile.host.availability.pause.period.thirty'
    },
    {
        value: '90',
        label: 'profile.host.availability.pause.period.ninety'
    },
    {
        value: '182', // FIXME: 182 or 180?
        label: 'profile.host.availability.pause.period.oneeighty'
    },
    {
        value: '365',
        label: 'profile.host.availability.pause.period.threesixtyfive'
    },
];

export const BOOKING_TYPES = [
    { value: "fixfee", label: 'general.feemode.fixfee' },
    { value: "hatwithguarantee", label: 'general.feemode.hatwithguarantee' },
    { value: "playingforhat", label: 'general.feemode.playingforhat' }
];


export const AGE_RANGES = [
    { value: 'children', label: 'profile.host.about.agerange.children' },
    { value: 'youth', label: 'profile.host.about.agerange.youth' },
    { value: 'age18', label: 'profile.host.about.agerange.age18' },
    { value: 'age25', label: 'profile.host.about.agerange.age25' },
    { value: 'age35', label: 'profile.host.about.agerange.age35' },
    { value: 'age45', label: 'profile.host.about.agerange.age45' },
];

export const ATMOSPHERE_TYPES = [
    { value: "happy", label: "profile.artist.music.atmosphere.happy" },
    { value: "dance", label: "profile.artist.music.atmosphere.dance" },
    { value: "calm", label: "profile.artist.music.atmosphere.calm" },
    { value: "festive", label: "profile.artist.music.atmosphere.festive" },
    { value: "lounge", label: "profile.artist.music.atmosphere.lounge" },
    { value: "experimental", label: "profile.artist.music.atmosphere.experimental" },
];

export const LINEUP_TYPES = [
    { value: "solo", label: "search.line_up.solo" },
    { value: "duo", label: "search.line_up.duo" },
    { value: "band", label: "search.line_up.band" },
    { value: "ensemble", label: "search.line_up.ensemble" },
    { value: "DJ", label: "search.line_up.DJ" },
];

export const SET_OPTIONS = [
    { value: "original", label: "profile.artist.experience.set_options.original" },
    { value: "cover", label: "profile.artist.experience.set_options.cover" },
    { value: "requests", label: "profile.artist.experience.set_options.requests" },
];


export const COPYRIGHT_TYPES = [
    { value: "gema", label: "profile.artist.experience.copyright.gema" },
    { value: "other", label: "profile.artist.experience.copyright.other" },
    { value: "SACEM", label: "profile.artist.experience.copyright.sacem" },
    { value: "AKM", label: "profile.artist.experience.copyright.akm" },
    { value: "SUISA", label: "profile.artist.experience.copyright.suisa" },
    { value: "none", label: "profile.artist.experience.copyright.none" }
]

export const GENRE_OPTIONS = [
    { value: "singer songwriter", label: "singer songwriter" },
    { value: "pop", label: "pop" },
    { value: "rock", label: "rock" },
    { value: "indie", label: "indie" },
    { value: "alternative", label: "alternative" },
    { value: "folk", label: "folk" },
    { value: "country", label: "country" },
    { value: "hiphop", label: "hiphop" },
    { value: "randb", label: "randb" },
    { value: "soul", label: "soul" },
    { value: "punk", label: "punk" },
    { value: "funk", label: "funk" },
    { value: "world music", label: "world music" },
    { value: "reggae", label: "reggae" },
    { value: "latin", label: "latin" },
    { value: "chanson", label: "chanson" },
    { value: "R&B", label: "R&B" },
    { value: "gospel", label: "gospel" },
    { value: "experimental", label: "experimental" },
    { value: "electronic", label: "electronic" },
    { value: "jazz", label: "jazz" },
    { value: "blues", label: "blues" },
    { value: "lounge", label: "lounge" },
    { value: "classical", label: "classical" },
    { value: "instrumental", label: "instrumental" },
    { value: "other", label: "other" },
];

export const EVENT_PRIVACY_OPTIONS = [
    { value: "public", label: "Public", icon: 'mdi-account-multiple' },
    { value: "invite", label: "Invite", icon: 'mdi-account-multiple-plus' },
    { value: "closed", label: "Closed", icon: 'mdi-account-key' },
    { value: "all", label: "Closed", icon: 'mdi-account-key' },
];

export const EVENT_TYPE_LINKS = {
    "de": {
        "sofaconcert": {
            "house": "/de/wohnzimmerkonzert",
            "house_warming": "/de/einweihungsparty-livemusik"
        },
        "birthday": {
            "house_concert": "/de/geburtstagsfeier-livemusik",
            "surprise": "/de/ueberraschung-livemusik"
        },
        "special_occassion": {
            "funeral": "de/trauerfeier",
            "commemoration": "de/trauerfeier",
            "hen_party": "/de/junggesellinnenabschied-jga-livemusik"
        },
        "wedding": {
            "singer": "/de/trauung",
            "party": "/de/hochzeitsfeier",
            "champagne": "/de/sektempfang",
            "walking_act": "/de/sektempfang",
        },
        "corporate_event": {
            "house_concert": "/de/sofablog/inspiration/firmenfeier_teamevent/190604_teambuilding-mit-musik",
            "christmas_concert": "/de/weihnachtsfeier-livemusik",
            "christmas_party": "/de/weihnachtsfeier-livemusik",
            "festival": "/de/firmenevents-livemusik"
        },
        "events_surprise": {
            "opening": "/de/livemusik-eventkonzepte-booking",
            "flashmob": "/de/livemusik-eventkonzepte-booking"
        },
    },
    "en": {


    }
};

export const TIME_OPTIONS = ['11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30'];

export const GLOBAL_CURRENCIES = [
    new Currency({
        iso_currency_code: 'EUR',
        title: 'general.currency.EUR',
        symbol: '€',
    }),
    new Currency({
        iso_currency_code: 'CHF',
        title: 'general.currency.CHF',
        symbol: 'CHF',
    }),

    new Currency({
        iso_currency_code: 'USD',
        title: 'US Dollar',
        symbol: '$',
    }),

    new Currency({
        iso_currency_code: 'GBP',
        title: 'British Pound',
        symbol: '£',
    })/*
    new Currency({iso_currency_code: 'CAD',
        title: 'Canadian Dollar',
        symbol: '$',
    })*/

]

export const SC_SOCIAL_SHARE_BASE_URLS = {
    'facebook': 'https://www.facebook.com/sharer/sharer.php?u={{url}}',
    'messenger': 'fb-messenger://share?link={{url}}&app_id={{app_id}}',
    'twitter': 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}',
    'whatsapp': 'https://api.whatsapp.com/send?text={{text}}&url={{url}}',
    'pinterest': ('http://www.pinterest.com/pin/create/button/' +
        '?url={{url}}&media={{image_url}}&description={{text}}')
}

export const HOST_TYPES = [
    "home",
    "cafe",
    "pub",
    "club",
    "studio",
    "commonroom",
    "eventseries",
    "other"
]

export const LANGUAGES = [
    {prio: '0', language: 'afar', alpha2: 'aa'},
    {prio: '0', language: 'afrikaans', alpha2: 'af'},
    {prio: '0', language: 'albanian', alpha2: 'sq'},
    {prio: '0', language: 'amharic', alpha2: 'am'},
    {prio: '0', language: 'arabic', alpha2: 'ar'},
    {prio: '0', language: 'armenian', alpha2: 'hy'},
    {prio: '0', language: 'assamese', alpha2: 'as'},
    {prio: '0', language: 'aymara', alpha2: 'ay'},
    {prio: '0', language: 'azerbaijani', alpha2: 'az'},
    {prio: '0', language: 'bashkir', alpha2: 'ba'},
    {prio: '0', language: 'basque', alpha2: 'eu'},
    {prio: '0', language: 'bengali (bangla)', alpha2: 'bn'},
    {prio: '0', language: 'bhutani', alpha2: 'dz'},
    {prio: '0', language: 'bihari', alpha2: 'bh'},
    {prio: '0', language: 'bislama', alpha2: 'bi'},
    {prio: '0', language: 'breton', alpha2: 'br'},
    {prio: '0', language: 'bulgarian', alpha2: 'bg'},
    {prio: '0', language: 'burmese', alpha2: 'my'},
    {prio: '0', language: 'byelorussian (belarusian)', alpha2: 'be'},
    {prio: '0', language: 'cambodian', alpha2: 'km'},
    {prio: '0', language: 'catalan', alpha2: 'ca'},
    {prio: '0', language: 'chinese (simplified)', alpha2: 'zh'},
    {prio: '0', language: 'chinese (traditional)', alpha2: 'zh'},
    {prio: '0', language: 'corsican', alpha2: 'co'},
    {prio: '0', language: 'croatian', alpha2: 'hr'},
    {prio: '0', language: 'czech', alpha2: 'cs'},
    {prio: '1', language: 'danish', alpha2: 'da'},
    {prio: '1', language: 'dutch', alpha2: 'nl'},
    {prio: '5', language: 'english', alpha2: 'en'},
    {prio: '0', language: 'esperanto', alpha2: 'eo'},
    {prio: '0', language: 'estonian', alpha2: 'et'},
    {prio: '0', language: 'faeroese', alpha2: 'fo'},
    {prio: '0', language: 'farsi', alpha2: 'fa'},
    {prio: '0', language: 'fiji', alpha2: 'fj'},
    {prio: '0', language: 'finnish', alpha2: 'fi'},
    {prio: '1', language: 'french', alpha2: 'fr'},
    {prio: '0', language: 'frisian', alpha2: 'fy'},
    {prio: '0', language: 'galician', alpha2: 'gl'},
    {prio: '0', language: 'gaelic (scottish)', alpha2: 'gd'},
    {prio: '0', language: 'gaelic (manx)', alpha2: 'gv'},
    {prio: '0', language: 'georgian', alpha2: 'ka'},
    {prio: '5', language: 'german', alpha2: 'de'},
    {prio: '0', language: 'greek', alpha2: 'el'},
    {prio: '0', language: 'greenlandic', alpha2: 'kl'},
    {prio: '0', language: 'guarani', alpha2: 'gn'},
    {prio: '0', language: 'gujarati', alpha2: 'gu'},
    {prio: '0', language: 'hausa', alpha2: 'ha'},
    {prio: '0', language: 'hebrew', alpha2: 'he'},
    {prio: '0', language: 'hindi', alpha2: 'hi'},
    {prio: '0', language: 'hungarian', alpha2: 'hu'},
    {prio: '0', language: 'icelandic', alpha2: 'is'},
    {prio: '0', language: 'indonesian', alpha2: 'id'},
    {prio: '0', language: 'interlingua', alpha2: 'ia'},
    {prio: '0', language: 'interlingue', alpha2: 'ie'},
    {prio: '0', language: 'inuktitut', alpha2: 'iu'},
    {prio: '0', language: 'inupiak', alpha2: 'ik'},
    {prio: '0', language: 'irish', alpha2: 'ga'},
    {prio: '1', language: 'italian', alpha2: 'it'},
    {prio: '0', language: 'japanese', alpha2: 'ja'},
    {prio: '0', language: 'javanese', alpha2: 'ja'},
    {prio: '0', language: 'kannada', alpha2: 'kn'},
    {prio: '0', language: 'kashmiri', alpha2: 'ks'},
    {prio: '0', language: 'kazakh', alpha2: 'kk'},
    {prio: '0', language: 'kinyarwanda (ruanda)', alpha2: 'rw'},
    {prio: '0', language: 'kirghiz', alpha2: 'ky'},
    {prio: '0', language: 'kirundi (rundi)', alpha2: 'rn'},
    {prio: '0', language: 'korean', alpha2: 'ko'},
    {prio: '0', language: 'kurdish', alpha2: 'ku'},
    {prio: '0', language: 'laothian', alpha2: 'lo'},
    {prio: '0', language: 'latin', alpha2: 'la'},
    {prio: '0', language: 'latvian (lettish)', alpha2: 'lv'},
    {prio: '0', language: 'limburgish ( limburger)', alpha2: 'li'},
    {prio: '0', language: 'lingala', alpha2: 'ln'},
    {prio: '0', language: 'lithuanian', alpha2: 'lt'},
    {prio: '0', language: 'macedonian', alpha2: 'mk'},
    {prio: '0', language: 'malagasy', alpha2: 'mg'},
    {prio: '0', language: 'malay', alpha2: 'ms'},
    {prio: '0', language: 'malayalam', alpha2: 'ml'},
    {prio: '0', language: 'maltese', alpha2: 'mt'},
    {prio: '0', language: 'maori', alpha2: 'mi'},
    {prio: '0', language: 'marathi', alpha2: 'mr'},
    {prio: '0', language: 'moldavian', alpha2: 'mo'},
    {prio: '0', language: 'mongolian', alpha2: 'mn'},
    {prio: '0', language: 'nauru', alpha2: 'na'},
    {prio: '0', language: 'nepali', alpha2: 'ne'},
    {prio: '0', language: 'norwegian', alpha2: 'no'},
    {prio: '0', language: 'occitan', alpha2: 'oc'},
    {prio: '0', language: 'oriya', alpha2: 'or'},
    {prio: '0', language: 'oromo (afan, galla)', alpha2: 'om'},
    {prio: '0', language: 'pashto (pushto)', alpha2: 'ps'},
    {prio: '0', language: 'polish', alpha2: 'pl'},
    {prio: '0', language: 'portuguese', alpha2: 'pt'},
    {prio: '0', language: 'punjabi', alpha2: 'pa'},
    {prio: '0', language: 'quechua', alpha2: 'qu'},
    {prio: '0', language: 'rhaeto-romance', alpha2: 'rm'},
    {prio: '0', language: 'romanian', alpha2: 'ro'},
    {prio: '0', language: 'russian', alpha2: 'ru'},
    {prio: '0', language: 'samoan', alpha2: 'sm'},
    {prio: '0', language: 'sangro', alpha2: 'sg'},
    {prio: '0', language: 'sanskrit', alpha2: 'sa'},
    {prio: '0', language: 'serbian', alpha2: 'sr'},
    {prio: '0', language: 'serbo-croatian', alpha2: 'sh'},
    {prio: '0', language: 'sesotho', alpha2: 'st'},
    {prio: '0', language: 'setswana', alpha2: 'tn'},
    {prio: '0', language: 'shona', alpha2: 'sn'},
    {prio: '0', language: 'sindhi', alpha2: 'sd'},
    {prio: '0', language: 'sinhalese', alpha2: 'si'},
    {prio: '0', language: 'siswati', alpha2: 'ss'},
    {prio: '0', language: 'slovak', alpha2: 'sk'},
    {prio: '0', language: 'slovenian', alpha2: 'sl'},
    {prio: '0', language: 'somali', alpha2: 'so'},
    {prio: '1', language: 'spanish', alpha2: 'es'},
    {prio: '0', language: 'sundanese', alpha2: 'su'},
    {prio: '0', language: 'swahili (kiswahili)', alpha2: 'sw'},
    {prio: '0', language: 'swedish', alpha2: 'sv'},
    {prio: '0', language: 'tagalog', alpha2: 'tl'},
    {prio: '0', language: 'tajik', alpha2: 'tg'},
    {prio: '0', language: 'tamil', alpha2: 'ta'},
    {prio: '0', language: 'tatar', alpha2: 'tt'},
    {prio: '0', language: 'telugu', alpha2: 'te'},
    {prio: '0', language: 'thai', alpha2: 'th'},
    {prio: '0', language: 'tibetan', alpha2: 'bo'},
    {prio: '0', language: 'tigrinya', alpha2: 'ti'},
    {prio: '0', language: 'tonga', alpha2: 'to'},
    {prio: '0', language: 'tsonga', alpha2: 'ts'},
    {prio: '0', language: 'turkish', alpha2: 'tr'},
    {prio: '0', language: 'turkmen', alpha2: 'tk'},
    {prio: '0', language: 'twi', alpha2: 'tw'},
    {prio: '0', language: 'uighur', alpha2: 'ug'},
    {prio: '0', language: 'ukrainian', alpha2: 'uk'},
    {prio: '0', language: 'urdu', alpha2: 'ur'},
    {prio: '0', language: 'uzbek', alpha2: 'uz'},
    {prio: '0', language: 'vietnamese', alpha2: 'vi'},
    {prio: '0', language: 'volapük', alpha2: 'vo'},
    {prio: '0', language: 'welsh', alpha2: 'cy'},
    {prio: '0', language: 'wolof', alpha2: 'wo'},
    {prio: '0', language: 'xhosa', alpha2: 'xh'},
    {prio: '0', language: 'yiddish', alpha2: 'yi'},
    {prio: '0', language: 'yoruba', alpha2: 'yo'},
    {prio: '0', language: 'zulu',alpha2:  'zu'}
]
